
































































import Vue, { PropType } from 'vue';
// 3rd party libraries
import moment from 'moment';
import { get } from 'vuex-pathify';

// models
import { Customer } from '@/models/customer';
import { Quote, QuoteType } from '@/models/quote';

export default Vue.extend({
  name: 'QuoteSummaryHeader',

  props: {
    quote: Object as PropType<Quote>,
    title: String
  },

  computed: {
    airwayIcon: get('app/airwayIcon'),

    isQuoteVentilation(): boolean {
      return (
        this.quote.type == QuoteType.RTU_VENTILATION ||
        this.quote.type == QuoteType.AIRWAY_VENTILATION
      );
    }
  },

  methods: {
    momentFormat(date: Date | string | number, days = 0) {
      return moment(date ?? new Date())
        .add(days, 'd')
        .format('LL')
        .toString();
    }
  }
});
